import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { colors, typography } from '../../../../styles/theme';
import { normalizeBuildingType } from '../../../utils/ufAttributeFormUtils';
import {
  getUfBuildingTypeIcon,
  UF_BUILDING_TYPE_ICON_LIST_SX,
  UF_BUILDING_TYPE_ICON_TILE_LIST_SX,
} from '../../../utils/ufBuildingTypeIcons';

/**
 * Paso 1 del wizard. `buildingTypes` sale de `resolveUfPropertyTypes`: los 7 tipos de
 * `property_fields.property_type.enum` (`{ id, label, buildingType }`) o los building_types
 * de siempre. `value` es el id seleccionado; `onChange` recibe la opción completa.
 */
const UfBuildingTypeStep = ({
  buildingTypes = [],
  value = '',
  disabled = false,
  onChange,
}) => {
  const selected = value || '';

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.75 }}>
      <Typography
        sx={{
          fontSize: '13px',
          color: '#ABABAB',
          lineHeight: 1.45,
          fontFamily: typography.fontFamily.primary,
        }}
      >
        Elegí el tipo de inmueble para cargar las características correspondientes.
      </Typography>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
          gap: 1.25,
        }}
      >
        {buildingTypes.map((option) => {
          const { id, label } = option;
          const normalizedId = id;
          const isActive = selected === normalizedId;
          const Icon = getUfBuildingTypeIcon(
            normalizeBuildingType(option.buildingType || id),
          );

          return (
            <Button
              key={normalizedId}
              disableElevation
              disabled={disabled}
              onClick={() => onChange?.(option)}
              aria-pressed={isActive}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 1,
                minHeight: 104,
                px: 1.5,
                py: 1.5,
                borderRadius: '8px',
                textTransform: 'none',
                border: '1px solid',
                borderColor: isActive ? colors.primary : '#383838',
                bgcolor: isActive ? 'rgba(72,146,145,0.16)' : '#242424',
                color: isActive ? '#E8F4F4' : colors.textPanelTitle,
                boxShadow: 'none',
                transition: 'background-color 0.15s ease, border-color 0.15s ease',
                '&:hover': {
                  bgcolor: isActive ? 'rgba(72,146,145,0.22)' : '#2a2a2a',
                  borderColor: isActive ? colors.primary : 'rgba(255,255,255,0.22)',
                  boxShadow: 'none',
                },
                '&.Mui-disabled': {
                  opacity: 0.55,
                },
              }}
            >
              <Box
                sx={{
                  ...UF_BUILDING_TYPE_ICON_TILE_LIST_SX,
                  bgcolor: isActive ? 'rgba(72,146,145,0.28)' : '#1C1C1C',
                  borderColor: isActive ? 'rgba(72,146,145,0.45)' : 'rgba(255,255,255,0.08)',
                }}
              >
                <Icon
                  sx={{
                    ...UF_BUILDING_TYPE_ICON_LIST_SX,
                    color: isActive ? '#E8F4F4' : '#E8F4F4',
                  }}
                />
              </Box>
              <Typography
                sx={{
                  fontSize: '13px',
                  fontWeight: isActive
                    ? typography.fontWeight.semibold
                    : typography.fontWeight.medium,
                  fontFamily: typography.fontFamily.primary,
                  color: 'inherit',
                  lineHeight: '16px',
                  textAlign: 'center',
                }}
              >
                {label}
              </Typography>
            </Button>
          );
        })}
      </Box>
    </Box>
  );
};

export default UfBuildingTypeStep;
